import { useState } from "react";
import api from "../../../Component/axios";
import Swal from "sweetalert2";

export const useProyeccionDiaria = () => {
  const token = localStorage.getItem("@Token");
  const id_campo = localStorage.getItem("codigo_campo");
  const [isProyeccionLoading, setIsProyeccionLoading] = useState({
    get: false,
    post: false,
  });

  const getProyeccion = async (fecha, cultivo) => {
    setIsProyeccionLoading({
      ...isProyeccionLoading,
      get: true,
    });
    try {
      const response = await api.get(
        `api/proyeccion-diaria/proyeccion_diaria/?fecha=${fecha}&cultivo=${cultivo}&campo=${localStorage.getItem(
          "codigo_campo"
        )}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      setIsProyeccionLoading({
        ...isProyeccionLoading,
        get: false,
      });
    }
  };

  const saveProyeccion = async (fecha, variedades) => {
    setIsProyeccionLoading({
      ...isProyeccionLoading,
      post: true,
    });
    try {
      const response = await api.post(
        "api/proyeccion-diaria/proyeccion_diaria/",
        {
          id_campo: Number(id_campo),
          fecha,
          data: variedades,
        },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: response.data.msg,
          // timer: 1500,
        });
        return;
      }
      Swal.fire({
        icon: "success",
        title: "Proyección guardada",
        timer: 1500,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
    } finally {
      setIsProyeccionLoading({
        ...isProyeccionLoading,
        post: false,
      });
    }
  };

  const deleteProyeccion = async (id) => {
    try {
      await api.delete(`api/proyeccion-diaria/proyeccion_diaria/${id}/`, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      throw error;
    }
  };

  return {
    getProyeccion,
    isProyeccionLoading,
    saveProyeccion,
    deleteProyeccion,
  };
};
